export enum CallerTypeQuestionValue {
	PoliceFire = 'PoliceFire',
	Customer = 'Customer',
	// For GLN, the call is on behalf of a company
	Company = 'Company',
}
